const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="main-footer">
        <p>Copyright &copy;{currentYear} Sugarloaf Web Solutions, LLC</p>
    </footer>
  )
}

export default Footer

